import { useCurrency } from '@/utils/CurrencyContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Globe } from 'lucide-react';

export const CurrencySelector = ({ className = '', compact = false }) => {
  const { currencies, selectedCurrency, changeCurrency, isLoading } = useCurrency();

  if (isLoading) {
    return (
      <div className={`flex items-center gap-1 ${className}`}>
        <Globe className="h-4 w-4 animate-pulse" style={{ color: '#5C635A' }} />
        <span className="text-sm" style={{ color: '#5C635A' }}>...</span>
      </div>
    );
  }

  const currentCurrency = currencies.find(c => c.code === selectedCurrency);

  return (
    <Select value={selectedCurrency} onValueChange={changeCurrency}>
      <SelectTrigger 
        className={`border-0 bg-transparent focus:ring-0 focus:ring-offset-0 ${className}`}
        style={{ minWidth: compact ? '70px' : '140px' }}
        data-testid="currency-selector"
      >
        <SelectValue>
          <div className="flex items-center gap-1">
            <Globe className="h-4 w-4" style={{ color: '#5C635A' }} />
            {compact ? (
              <span className="text-sm font-medium" style={{ color: '#163329' }}>
                {selectedCurrency}
              </span>
            ) : (
              <span className="text-sm" style={{ color: '#163329' }}>
                {currentCurrency?.symbol} {selectedCurrency}
              </span>
            )}
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {currencies.map((currency) => (
          <SelectItem 
            key={currency.code} 
            value={currency.code}
            data-testid={`currency-option-${currency.code}`}
          >
            <div className="flex items-center justify-between w-full gap-4">
              <span className="font-medium">{currency.symbol}</span>
              <span>{currency.code}</span>
              <span className="text-xs" style={{ color: '#5C635A' }}>{currency.name}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
